<template>
    <div class="articalss-box">
        <div class="left">
            <div class="centerbox" @click='pathto(news.id)'>
                <h5 class="date">{{news.date}}</h5>
                <h3 class="uptitle">{{news.caption}}</h3>
            </div>
        </div>
        <div class="right">
            <h3 class="caption">{{artical.caption}}</h3>
            <div class="content" v-html='artical.content'></div>
            <div class="tip" v-html='artical.title'></div>
            <div class="bank" @click='historygo'>返回</div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Articalss',
        data() {
            return {
                blogData: '',
                artical: {
                    caption: '文章获取失败',
                    content: '文章获取失败',
                    title: '声明本资料仅供学习交流，严禁使用于任何商业用途! 转载请注明出处，违者必究。<br/>Copyright Paton. Brand all rights reserved. ',
                },
                news: {
                    date: '时间获取失败',//时间
                    id: '1',//文章id
                    caption: '获取失败',//文章标题
                },
                newsId:null
            }
        },
        mounted() {
            this.geUrlId()
        },
        methods: {
            getID() {
                let id = window.sessionStorage.getItem('articalid')
                this.getArtical(id)
            },
            geUrlId() {
                let id = window.location.href.split('?id=')
                if (id[1] == '' || id[1] == null) {//没有传id
                    this.getID()
                } else {//传了id
                    this.getArtical(id[1])
                }
            },
            getArtical(id) {//获取文章详情
                this.$axios.get(this.$API.lookArticl + `/${id}`)
                    .then(res => {
                        this.artical.caption = res.data.data.title
                        this.artical.content = res.data.data.content
                        this.newsId=res.data.data.article_type_id
                        this.getList(this.newsId, 1)
                        // console.log(res.data.data)
                    })
                    .catch(error => {
                        this.$message.error('文章获取失败')
                    })
            },
            pathto(id) {
                window.sessionStorage.setItem('articalid', id)
                window.location.href = `/artical/${this.news.caption}?id=${id}`
            },
            getList(id, page) {//获取文章列表
                this.$axios.get(this.$API.lookArticl, {
                    params: {
                        'article_type_id': id,
                        'per_page': 5,
                        'page': page
                    }
                }
                )
                    .then(res => {
                        this.blogData = res.data.data[0]
                        this.news.date = this.blogData.created_at
                        this.news.date = this.news.date.split(' ')[0]
                        this.news.caption = this.blogData.title
                        this.news.id = this.blogData.id
                    })
                    .catch(err => {
                        this.$message.error('文章列表获取失败，刷新页面重试')
                    })
            },
            historygo(){//返回
                window.history.back()
            }

        }
    }
</script>
<style scoped>
    .articalss-box {
        padding: 88px 140px;
        width: 100%;
        display: grid;
        grid-template-columns: 30% 70%;
    }

    .content {
        padding-top: 48px;
    }

    .caption {
        font-size: 32px;
        font-weight: 400;
        line-height: 150%;
        color: rgba(51, 51, 51, 1);
        padding-bottom: 48px;
        border-bottom: 1px solid #999999;
    }

    .tip {
        padding-top: 92px;
        padding-bottom: 35px;
        font-size: 16px;
        font-weight: 400;
        line-height: 175%;
        color: rgba(204, 204, 204, 1);
        border-bottom: 1px solid #CCCCCC;
    }

    .bank {
        padding-top: 22px;
        font-size: 16px;
        font-weight: 400;
        line-height: 175%;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
    }

    .date {
        font-size: 20px;
        font-weight: 400;
        line-height: 140%;
        color: rgba(102, 102, 102, 1);
    }

    .uptitle {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 175%;
        color: rgba(153, 153, 153, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .centerbox {
        cursor: pointer;
        max-width: 50%;
    }

    @media(max-width: 995px) {
        .left {
            display: none;
        }

        .articalss-box {
            padding: 5%;
            grid-template-columns: 1fr;
        }
        .caption{
            font-size: 24px;
        }
        .bank {
        font-size: 16px;
    }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/school/articles.vue